/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import 'moment/locale/pt';

import moment from 'moment'
import { Box, Button, Tab, Tabs, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import styled from 'styled-components';
import { enqueueSnackbar } from 'notistack';

export default function OrderModal({ open, onClose, setOrderValues, setOrdering }) {
  const [type, setType] = useState(null);
  const [value, setValue] = useState(0);

  const handleReturnInfos = () => {
    if (type === null) {
      enqueueSnackbar('Escolha um tipo de ordenação', { variant: 'info' });
      return
    }
    moment.locale('en')

    if (value === 0) {
      setOrderValues(`&sortField=id&sortType=${type}`)
    } else {
      setOrderValues(`&sortField=name&sortType=${type}`)
    }

    setOrdering(true)
    onClose()
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const Label = styled(Typography)(({ theme }) => ({
    '&': {
      fontSize: '16px',
      marginBottom: '10px'
    },
  }))

  const handleAlignment = (event, newAlignment) => {
    setType(newAlignment);
  };

  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: 24,
      borderRadius: 2,
      backgroundColor: grey[300]
    }}>
      <Box sx={{
        padding: '16px',
        borderRadius: '8px 8px 0 0',
        backgroundColor: '#fff'
      }}>
        <Typography variant="h6" component="h2">
          Ordenação
        </Typography>
      </Box>

      <Box sx={{
        margin: '16px',
        width: 400,
        height: '100%',
        backgroundColor: '#fff',
        borderRadius: 1,
      }}>
        <Box sx={{
          width: '100%'
        }}>
          <Box sx={{
            borderBottom: 1,
            borderColor: 'divider'
          }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Por ID" {...a11yProps(0)} />
              <Tab label="Por ordem alfabética" {...a11yProps(1)} />
            </Tabs>
          </Box>

          <TabPanel value={value} index={0}>
            <Box>
              <ToggleButtonGroup
                value={type}
                exclusive
                onChange={handleAlignment}
                sx={{width: '100%', gap: 2}}
              >
                <ToggleButton sx={{width: '100%'}} value="asc">
                  Crescente
                </ToggleButton>
                <ToggleButton sx={{width: '100%'}} value="desc">
                  Decrescente
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <Box>
              <ToggleButtonGroup
                value={type}
                exclusive
                onChange={handleAlignment}
                sx={{width: '100%', gap: 2}}
              >
                <ToggleButton sx={{width: '100%'}} value="asc">
                  Crescente
                </ToggleButton>
                <ToggleButton sx={{width: '100%'}} value="desc">
                  Decrescente
                </ToggleButton>
              </ToggleButtonGroup>
              
            </Box>
          </TabPanel>
        </Box>
      </Box>

      <Box sx={{
        display: 'flex',
        width: '100%',
        justifyContent: 'flex-end',
        gap: 1,
        padding: 2,
        borderRadius: '0 0 8px 8px',
        backgroundColor: '#fff'
      }}>
        <Button disabled={type === null} variant="contained" color={'success'} onClick={() => handleReturnInfos()}>
          <Typography color={'#fff'}>
            Ordenar
          </Typography>
        </Button>
        <Button variant="contained" onClick={onClose}>
          <Typography color={'#fff'}>
            Fechar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}
